import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiUrls } from 'src/app/services/ApiUrls';


@Injectable({
  providedIn: 'root'
})
export class RegSupportUserService {
  constructor(public httpClient: HttpClient) { }

  //load channel rest
  async loadChannel() {
    // const url = (await grievanceServerUrl) + "loadChannel";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadChannel, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load board rest
  async loadBoard() {
    // const url = (await grievanceServerUrl) + "loadBoards";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadBoard, {})
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //load grievance type with board id rest
  async loadGrievance(deptId: any) {
    const data = { 'depId': deptId, };
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.loadGrievanceByDpid, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //

  //submit grievance lottery user with support user
  async submitGrievance(data: any) {
    // const url = (await grievanceServerUrl) + "createGrievanceForLotteryUserBySE";
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.createGrievanceForLotteryUserBySE, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  ///

  //load lottery user under reg id
  async loadRegUserById(data: any) {
 
    return new Promise((resolve) => {
      this.httpClient
        .post(ApiUrls.listOfRegUserDetails, data)
        .toPromise()
        .then((res) => {
          resolve(res);
        })
        .catch((resp: Response) => {
          resolve(resp);
        });
    });
  }
  //


    //load lottery within board id rest
    async loadLottery(boardId: any) {
      const data = { 'bdId': boardId, };
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadLottery, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }


    async loadDepartment(boardId){
      const data = { 'bdId': boardId, };
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadDepartment, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }


    async loadApplications(lotteryId,userid){
      const data = { 'lotteryId': lotteryId, userID:userid };
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadApplication, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }


    async loadPayment(applicationId){
      const data = { 'appliId': applicationId, };
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.loadOnlinePayment, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }


    async isCheckDeuplicate(data){
      
      return new Promise((resolve) => {
        this.httpClient
          .post(ApiUrls.isDuplicateGrievance, data)
          .toPromise()
          .then((res) => {
            resolve(res);
          })
          .catch((resp: Response) => {
            resolve(resp);
          });
      });
    }

    async loadFaqLink(grievanceTypeId){
      const data = { 'grievanceTypeId': grievanceTypeId, };
      // const url = (await grievanceServerUrl) + "loadApplication";
      // return new Promise((resolve) => {
      //   this.httpClient
      //     .post(url, data)
      //     .toPromise()
      //     .then((res) => {
      //       resolve(res);
      //     })
      //     .catch((resp: Response) => {
      //       resolve(resp);
      //     });
      // });
  
      return "https://www.tutorialspoint.com/java_cryptography/java_cryptography_message_digest.htm"
    }

}

